// extracted by mini-css-extract-plugin
export default {"form":"Defaults_form__VD-Cv","field":"Defaults_field__Q2K5Q","saveBtn":"Defaults_saveBtn__mZvBg","hint":"Defaults_hint__QlhZn","status":"Defaults_status__3k7Zw"};